import React from 'react';
import { Route, Switch } from 'react-router';
import { shoppingMenuRoutes } from '../constants';

export const ShoppingMenuRoutes = () => {

  return (
		<Switch>
			{
				[shoppingMenuRoutes.map((route, index) => {
					return (
						<Route 
							key={index}
							path={route.path}
							exact={route.exact}
							render={() => <route.component />} />													
					)
					})					
				]
			}
		</Switch>
	);
}
